<template>
  <div>
    <div>
      <div class="categorias m-tb">Molde Fechado</div>

      <div class="items-row-img">
        <div class="img-exp">
          <!-- Condicional de Fotos  -->
          <div v-if="data.IMG_MF_PLA_ID != null" class="conteudo">
            <img :src="this.$store.state.ImgURL + data.IMG_MF_PLA_ID+'.webp'" alt="Não Aplicável" />
          </div>
          <div v-else class="conteudo">Não Aplicável</div>
          <!--  -->
          <div class="legenda">Plaqueta de Identificação do molde</div>
        </div>
        <div class="img-exp">
          <!-- Condicional de Fotos  -->
          <div v-if="data.IMG_MF_CAM_QUENTE != null" class="conteudo">
            <img :src="this.$store.state.ImgURL + data.IMG_MF_CAM_QUENTE+'.webp'" alt="Não Aplicável" />
          </div>
          <div v-else class="conteudo">Não Aplicável</div>
          <!--  -->
          <div class="legenda">ID da Câmara Quente</div>
        </div>

        <div class="img-exp">
          <!-- Condicional de Fotos  -->
          <div v-if="data.IMG_MF_L_DIREITO != null" class="conteudo">
            <img :src="this.$store.state.ImgURL + data.IMG_MF_L_DIREITO+'.webp'" alt="Não Aplicável" />
          </div>
          <div v-else class="conteudo">Não Aplicável</div>
          <!--  -->
          <div class="legenda">Lado Direito</div>
        </div>
      </div>
      <div class="items-row-img">
        <div class="img-exp">
          <!-- Condicional de Fotos  -->
          <div v-if="data.IMG_MF_L_ESQUERDO != null" class="conteudo">
            <img :src="this.$store.state.ImgURL + data.IMG_MF_L_ESQUERDO+'.webp'" alt="Não Aplicável" />
          </div>
          <div v-else class="conteudo">Não Aplicável</div>
          <!--  -->
          <div class="legenda">Lado Esquerdo</div>
        </div>

        <div class="img-exp">
          <!-- Condicional de Fotos  -->
          <div v-if="data.IMG_MF_PLA_L_MOVEL != null" class="conteudo">
            <img :src="this.$store.state.ImgURL + data.IMG_MF_PLA_L_MOVEL+'.webp'" alt="Não Aplicável" />
          </div>
          <div v-else class="conteudo">Não Aplicável</div>
          <!--  -->
          <div class="legenda">Foto da Placa do Lado Móvel</div>
        </div>
        <div class="img-exp">
          <!-- Condicional de Fotos  -->
          <div v-if="data.IMG_MF_PLA_L_FIXO != null" class="conteudo">
            <img :src="this.$store.state.ImgURL + data.IMG_MF_PLA_L_FIXO+'.webp'" alt="Não Aplicável" />
          </div>
          <div v-else class="conteudo">Não Aplicável</div>
          <!--  -->
          <div class="legenda">Foto da Placa do Lado Fixo</div>
        </div>
      </div>

      <div class="items-row-img">
        <div class="img-exp">
          <!-- Condicional de Fotos  -->
          <div v-if="data.IMG_MF_L_SUPERIOR != null" class="conteudo">
            <img :src="this.$store.state.ImgURL + data.IMG_MF_L_SUPERIOR+'.webp'" alt="Não Aplicável" />
          </div>
          <div v-else class="conteudo">Não Aplicável</div>
          <!--  -->
          <div class="legenda">Foto do Lado Superior</div>
        </div>

        <div class="img-exp">
          <!-- Condicional de Fotos  -->
          <div v-if="data.IMG_MF_PLA_SIS_REF != null" class="conteudo">
            <img :src="this.$store.state.ImgURL + data.IMG_MF_PLA_SIS_REF+'.webp'" alt="Não Aplicável" />
          </div>
          <div v-else class="conteudo">Não Aplicável</div>
          <!--  -->
          <div class="legenda">Plaqueta do sistema de refrigeração</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
  },
};
</script>

<style>
.m-tb {
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
}

.items-row-img {
  justify-content: space-around !important;
}
</style>
